export const PRODUCTS_INDEX_TOUR = {
  id: "products_index",
  steps: [
    {
      element: '[data-tour="products-create"]',
      popover: {
        title: "Novo produto",
        description:
          "Produtos são pacotes avulsos de créditos que o cliente pode comprar fora do plano.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="products-list"]',
      popover: {
        title: "Seus produtos",
        description: "Veja tipo, créditos, preço e status de cada produto cadastrado.",
        side: "top",
      },
    },
  ],
};
